// extracted by mini-css-extract-plugin
export default {"container":"CsrIwl","withDivider":"JSlVyv","whenThreeColumns":"BnmySN","whenTwoColumns":"TWHuR7","whenOneColumns":"yDBimX"};